export default __webpack_public_path__ + "static/media/Shafana.bd87ee6f.jpeg";